export default function pathNode(strokeWidth, strokeColor = '#f6f6f6') {
  // Create single path element
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('stroke', strokeColor);
  path.setAttribute('fill', 'none');
  path.setAttribute('stroke-width', strokeWidth);

  return path;
}
